module.exports = __webpack_public_path__ + "img/guide-student11.4f53b4f4.png";